import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * The standalone "report an absence" form (ParentChildAbsence) was retired —
 * reporting an absence now happens on the child's calendar, where a parent can
 * pick a date range and see exactly which school days will be marked. This
 * preserves the old deep link (/parent/:studentId/absence/new) by sending it to
 * the calendar in absence mode (?report=1).
 */
const AbsenceToCalendarRedirect: React.FC = () => {
  const { studentId } = useParams<{ studentId: string }>();
  return <Navigate to={`/parent/${studentId}/calendar?report=1`} replace />;
};

export default AbsenceToCalendarRedirect;
